/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSVorleistung from '../../models/TSVorleistung';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Vorleistung Angaben
 *
 */
export default class VorleistungRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public saveVorleistung(schadenfallId: string, vorleistung?: TSVorleistung): IPromise<TSVorleistung | undefined> {
        if (vorleistung) {
            let restVorleistung: any = vorleistung.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'vorleistungen/' + encodeURIComponent(schadenfallId), restVorleistung)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSVorleistung().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public deleteVorleistung(vorleistung: TSVorleistung): IPromise<any> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'vorleistungen/' + encodeURIComponent(vorleistung.id))
            .then((response) => {
                return response;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/VorleistungenRS.ts